import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Table, Button } from 'reactstrap';
import { useTenantAdmins, type TenantAdminMembership } from '../../api/platformTenants';
import { TenantAdminDrawer } from '../../components/tenants/TenantAdminDrawer';
import { TenantAdminResetPasswordModal } from '../../components/tenants/TenantAdminResetPasswordModal';
import { StatusBadge } from '../../components/StatusBadge';

interface Props { tenantId: number; disabled: boolean; }

export default function TenantDetailAdmins({ tenantId, disabled }: Props) {
  const auth = useAuth();
  const token = auth.user?.access_token ?? null;

  const { data, isLoading } = useTenantAdmins(tenantId, token);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [resetFor, setResetFor] = useState<TenantAdminMembership | null>(null);

  return (
    <div>
      <div className="d-flex justify-content-end mb-2">
        <Button type="button" color="primary" size="sm" disabled={disabled}
                onClick={() => setDrawerOpen(true)}>+ Aggiungi tenant-admin</Button>
      </div>
      {isLoading ? <p>Caricamento…</p> : (
        <div className="table-responsive">
        <Table className="table-sm align-middle table-striped mb-0" style={{ width: '100%' }}>
          <thead><tr><th>Email</th><th>Display</th><th>Status</th><th>Assigned</th><th /></tr></thead>
          <tbody>
            {data?.data.map((m) => (
              <tr key={m.id}>
                <td>{m.email ?? '—'}</td>
                <td>{m.display_name ?? '—'}</td>
                <td><StatusBadge tone={m.status === 'active' ? 'success' : 'warn'}>{m.status}</StatusBadge></td>
                <td style={{ fontFamily: 'var(--vp-font-mono)', fontSize: 12 }}>{m.assigned_at}</td>
                <td>
                  <Button type="button" color="light" size="sm"
                          disabled={disabled || m.status !== 'active'}
                          onClick={() => setResetFor(m)}>
                    Reset password
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      )}

      <TenantAdminDrawer tenantId={tenantId} isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
      {resetFor && (
        <TenantAdminResetPasswordModal
          tenantId={tenantId}
          admin={resetFor}
          onClose={() => setResetFor(null)}
        />
      )}
    </div>
  );
}
